// extracted by mini-css-extract-plugin
export default {"Preface":"AboutCodeOfConduct_Preface__Lcm3L","Container":"AboutCodeOfConduct_Container__i-O+U","Content":"AboutCodeOfConduct_Content__4Lq-y"};